/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "../../mutations"
import actions from "./actions"
Vue.use(Vuex)

import moduleDrivers from './drivers/moduleDrivers'
import moduleVehicles from './vehicles/moduleVehicles'
import moduleTrips from './trips/moduleTrips'
import moduleZones from './zones/moduleZones'
import moduleRoutes from './routes/moduleRoutes'
import moduleGroups from './groups/moduleGroups'
import moduleCoupons from './coupons/moduleCoupons'
import moduleUsers from './users';
import moduleCustomers from './customers';
import moduleAuth from "./auth/moduleAuth";
import modulePartners from './partners'
import moduleMetrics from './metrics'
import moduleOrders from './orders'
import moduleCustomFields from './customFields'

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
      auth : moduleAuth,
      metrics : moduleMetrics,
      customers : moduleCustomers,
      groups : moduleGroups,
      users: moduleUsers,
      drivers: moduleDrivers,
      vehicles: moduleVehicles,
      trips: moduleTrips,
      zones : moduleZones,
      routes : moduleRoutes,
      coupons: moduleCoupons,
      partners: modulePartners,
      orders : moduleOrders,
      customFields: moduleCustomFields
    },
    strict: process.env.NODE_ENV !== 'production'
})
